var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54455 10.1479L4.31897 8.02991C3.99257 7.81559 3.90322 7.41088 4.11368 7.09996L7.33926 2.33456C7.6412 1.88848 8.3588 1.88848 8.66074 2.33456L11.8863 7.09996C12.0968 7.41088 12.0074 7.81559 11.681 8.02991L8.45545 10.1479C8.18393 10.3262 7.81607 10.3262 7.54455 10.1479Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54359 10.8434L4.99411 9.17276C4.72006 8.99317 4.37129 9.28402 4.54788 9.5449L7.3377 13.6665C7.63965 14.1126 8.35724 14.1126 8.65919 13.6665L11.449 9.5449C11.6256 9.28402 11.2768 8.99317 11.0028 9.17276L8.4533 10.8434C8.18202 11.0212 7.81487 11.0212 7.54359 10.8434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkEthereum);
export default __webpack_public_path__ + "static/media/network_Ethereum.6befd0e2968b53a79c13895425581124.svg";
export { ForwardRef as ReactComponent };